export default __webpack_public_path__ + "static/media/callIcon.8128feac.svg";